import { Box, Drawer, Button, Link, Typography } from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import { Link as RouterLink } from 'react-router-dom'; // Import RouterLink for navigation
import CompactLeadForm from '../components/CompactLeadForm';
import CompactTestimonialLeadForm from '../components/CompactTestimonialLeadForm';
import { isFeatureEnabled } from '../featureFlags';

const Sidebar = ({ isMobile, sidebarOpen, toggleSidebar }) => {
  // Handle link clicks to close the sidebar
  const handleLinkClick = () => {
    if (isMobile) {
      toggleSidebar(); // Close the sidebar on mobile
    }
  };

  return (
    <Drawer
      variant={isMobile ? 'temporary' : 'permanent'}
      open={isMobile ? sidebarOpen : true}
      onClose={toggleSidebar}
      sx={{
        width: 256,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 256,
          boxSizing: 'border-box',
          padding: '16px',
        },
      }}
    >
      {isMobile && (
        <Button
          onClick={toggleSidebar}
          sx={{
            mt: 1.6,
            mb: 1,
            ml: 1,
            textAlign: 'left', // Aligns the text inside the button to the left
            justifyContent: 'left',
            alignItems: 'center',
            width: '100%',     // Ensures it takes the full width available
            paddingLeft: 0,    // Optional: Remove any internal padding if needed to align text perfectly
          }}
        >
          <KeyboardArrowLeft />
          Close Sidebar
        </Button>
      )}

      <Box sx={{ pb: 2, pl: 2, pr: 2, pt: 1 }}>
        {/*<Typography variant="h6">Navigation</Typography>*/}

        {/* Sidebar Links */}
        <Box sx={{ marginTop: 4 }}>
          <Link
            component={RouterLink}
            to="/"
            onClick={handleLinkClick} // Close the sidebar when clicked
            sx={{ display: 'block', marginBottom: 4, color: 'inherit', textDecoration: 'none' }}
          >
            Home
          </Link>
          <Link
            component={RouterLink}
            to="/about"
            onClick={handleLinkClick} // Close the sidebar when clicked
            sx={{ display: 'block', marginBottom: 4, color: 'inherit', textDecoration: 'none' }}
          >
            About
          </Link>
          <Link
            component={RouterLink}
            to="/salary-calculator"
            onClick={handleLinkClick} // Close the sidebar when clicked
            sx={{ display: 'block', marginBottom: 4, color: 'inherit', textDecoration: 'none' }}
          >
            UK Take Home Pay Calculator
          </Link>
          {isFeatureEnabled('SALARY_COMPARISON') && (
            <Link
              component={RouterLink}
              to="/salary-comparison"
              onClick={handleLinkClick} // Close the sidebar when clicked
              sx={{ display: 'block', marginBottom: 4, color: 'inherit', textDecoration: 'none' }}
            >
              Compare Salaries
            </Link>
          )}
          {isFeatureEnabled('SIMPLE_TAKE_HOME_CALCULATOR') && (
            <Link
              component={RouterLink}
              to="/tools/take-home-simple"
              onClick={handleLinkClick} // Close the sidebar when clicked
              sx={{ display: 'block', marginBottom: 4, color: 'inherit', textDecoration: 'none' }}
            >
              Simple Take-Home Calculator
            </Link>
          )}
          {isFeatureEnabled('PAY_RISE_SIMULATOR') && (
            <Link
              component={RouterLink}
              to="/pay-rise-simulator"
              onClick={handleLinkClick} // Close the sidebar when clicked
              sx={{ display: 'block', marginBottom: 4, color: 'inherit', textDecoration: 'none' }}
            >
              Pay Rise Simulator
            </Link>
          )}
          <Link
            component={RouterLink}
            to="/about-the-salary-calculator"
            onClick={handleLinkClick} // Close the sidebar when clicked
            sx={{ display: 'block', marginBottom: 4, color: 'inherit', textDecoration: 'none' }}
          >
            About the UK Take Home Pay Calculator
          </Link>
        </Box>

        {/* Quick Calculators Section - Same level as other headings */}
        <Box sx={{ marginTop: 4, borderLeft: '2px solid #ccc', paddingLeft: 2 }}>
          <Typography 
            variant="h6" 
            sx={{ 
              mb: 2,
              fontSize: '1rem',
              fontWeight: 900
            }}
          >
            Quick Calculators
          </Typography>
          
          {[
            { 
              amount: '25,000', 
              url: '/25000-after-tax-uk',
              text: '£25k After Tax UK',
              description: '£25,000 salary calculator'
            },
            { 
              amount: '30,000', 
              url: '/30000-after-tax-uk',
              text: '£30k After Tax UK',
              description: '£30,000 salary calculator'
            },
            { 
              amount: '40,000', 
              url: '/40000-after-tax-uk',
              text: '£40k After Tax UK',
              description: '£40,000 salary calculator'
            },
            { 
              amount: '50,000', 
              url: '/50000-after-tax-uk',
              text: '£50k After Tax UK',
              description: '£50,000 salary calculator'
            },
            { 
              amount: '60,000', 
              url: '/60000-after-tax-uk',
              text: '£60k After Tax UK',
              description: '£60,000 salary calculator'
            }
          ].map((item) => (
            <Link
              key={item.amount}
              component={RouterLink}
              to={item.url}
              onClick={handleLinkClick}
              title={item.description}
              sx={{ 
                display: 'block',
                marginBottom: 4,
                color: 'inherit', 
                textDecoration: 'none',
                '&:hover': {
                  color: 'primary.main'
                }
              }}
            >
              {item.text}
            </Link>
          ))}
        </Box>

        {/* Compact Lead Forms */}
        {isFeatureEnabled('COMPACT_LEAD_FORM') && (
          <Box sx={{ marginTop: 4 }}>
            <CompactLeadForm />
          </Box>
        )}
        
        {isFeatureEnabled('COMPACT_TESTIMONIAL_LEAD_FORM') && (
          <Box sx={{ marginTop: 4 }}>
            <CompactTestimonialLeadForm 
              title="Get salary optimization tips"
              buttonText="Get instant access"
            />
          </Box>
        )}
      </Box>
    </Drawer>
  );
};

export default Sidebar;
